const initialState = {
  data: null,
}

export default (state = initialState) => {
  return state
}
